import styles from './EditPriceTabItems.module.css';
import { Grid, ListItem } from '@mui/material';
import { splitArray } from '@/services/menu/menus.helper.service';
import { Modifier } from '@/types/menus.types';

export const ProductsModifierIncluded = ({ modifiers }: { modifiers: Modifier[] }) => {
  const sortedModifiers = modifiers.sort(
    (a, b) =>
      a.modifierName.localeCompare(b.modifierName) || a.modifierDescription.localeCompare(b.modifierDescription),
  );
  const [modifierOne, modifierTwo] = splitArray(sortedModifiers);

  return (
    <>
      <div className={styles.productInfo}>Modifiers Included</div>
      <Grid container direction="row" justifyContent="space-between" alignItems="left">
        <Grid item>
          {modifierOne.map((modifier) => (
            <ListItem key={modifier.variantId}>
              <p>
                <li>
                  <span className={styles.productsIncluded}>
                    {modifier.modifierName}, {modifier.modifierDescription}
                  </span>
                </li>
              </p>
            </ListItem>
          ))}
        </Grid>
        <Grid item>
          {modifierTwo.map((modifier) => (
            <ListItem key={modifier.variantId}>
              <p>
                <li>
                  <span className={styles.productsIncluded}>
                    {modifier.modifierName}, {modifier.modifierDescription}
                  </span>
                </li>
              </p>
            </ListItem>
          ))}
        </Grid>
      </Grid>
    </>
  );
};
